import React from 'react';
import { FormImageFieldModal } from '../../../../media-management/components/form-image/FormImageFieldModal';
import { ElementWrapper } from '../../../components/ElementWrapper';
import { IElement } from '../../../models/Element';
import { PluginLeftImageInfo } from './PluginLeftImageInfo';
import { PluginLeftImageInfoContent } from './PluginLeftImageInfoContent';
import { PluginLeftImageInfoFigure } from './PluginLeftImageInfoFigure';

type Props = {
  index: number;
  data: PluginLeftImageInfo;
  updateData: (element: IElement, index: number) => void;
};

export const PluginLeftImageInfoFC: React.FC<Props> = ({
  index,
  data,
  updateData,
}) => {
  const update = (fieldsToUpdate: Partial<PluginLeftImageInfo>) => {
    const updatedData = { ...data, ...fieldsToUpdate };
    updateData(updatedData, index);
  };
  return (
    <>
      <FormImageFieldModal
        modalId={`${data.name}-${data.id}`}
        name={`image`}
        altText={`image_alt`}
        update={update}
      />

      <ElementWrapper elementIndex={index}>
        <div className="plugin-left-image-info">
          <div className="showcase">
            <PluginLeftImageInfoContent data={data} update={update} />
            <PluginLeftImageInfoFigure data={data} update={update} />
          </div>
        </div>
      </ElementWrapper>
    </>
  );
};
